import { NgModule } from '@angular/core';
import { JazzplanComponent } from './jazzplan.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [JazzplanComponent],
  imports: [SharedModule],
})
export class JazzplanModule {}
